import LegalPage from "@/components/LegalPage";

const TerminiCondizioni = () => (
  <LegalPage
    testid="page-termini"
    title="Condizioni d'uso del sito"
    subtitle="Regole per la navigazione e l'utilizzo dei contenuti istituzionali."
    sections={[
      {
        h: "1. Titolare e gestore del sito",
        p: [
          "Il Sito https://medisistem.it (il \u201cSito\u201d) è gestito da Medisistem snc di Mario de Peppo & C., con sede in Via Giuseppe Bonito 19, Napoli, P. IVA 06546510634 (di seguito \u201cMedisistem\u201d o il \u201cGestore\u201d).",
        ],
        list: [
          "Email: info@medisistem.it",
          "PEC: medisistem@pec.it",
          "Telefono: 081 7433033",
        ],
      },
      {
        h: "2. Oggetto e ambito di applicazione",
        p: [
          "Le presenti Condizioni disciplinano l'accesso al Sito, la consultazione dei contenuti istituzionali, delle informazioni sui prodotti e sui servizi, nonché l'utilizzo dei moduli di contatto e di prenotazione della misurazione. Gli acquisti effettuati attraverso la futura sezione e-commerce saranno disciplinati da separate Condizioni generali di vendita, che il consumatore dovrà poter consultare e accettare prima dell'invio dell'ordine.",
        ],
      },
      {
        h: "3. Utilizzo corretto del Sito",
        p: [
          "L'utente si impegna a utilizzare il Sito in modo lecito, corretto e rispettoso dei diritti di Medisistem e di terzi. È vietato, in particolare:",
        ],
        list: [
          "tentare di accedere senza autorizzazione a sistemi, dati, aree riservate o funzionalità del Sito;",
          "interferire con il funzionamento del Sito, aggirare misure di sicurezza o effettuare invii automatizzati, massivi o fraudolenti;",
          "trasmettere contenuti illeciti, offensivi, ingannevoli, dannosi o lesivi di diritti altrui;",
          "riprodurre o utilizzare contenuti del Sito per finalità commerciali senza autorizzazione, salvo gli usi consentiti dalla legge.",
        ],
      },
      {
        h: "4. Informazioni su salute e prodotti medicali",
        p: [
          "I contenuti del Sito hanno finalità informative e commerciali generali. Non costituiscono diagnosi, prescrizione, consulto medico o sostituzione del rapporto con un medico o altro professionista sanitario qualificato. L'utente deve utilizzare i prodotti nel rispetto della destinazione d'uso, delle istruzioni, delle avvertenze e dell'etichettatura predisposte dal fabbricante. In caso di dubbi sull'idoneità di un prodotto rispetto alle proprie condizioni, è opportuno rivolgersi al medico o al professionista sanitario competente. Le informazioni obbligatorie, le istruzioni d'uso e l'etichettatura del prodotto prevalgono su eventuali descrizioni sintetiche presenti nel Sito.",
        ],
      },
      {
        h: "5. Moduli di contatto e prenotazione della misurazione",
        p: [
          "I moduli sono destinati esclusivamente a richieste di contatto, informazioni commerciali e prenotazione del servizio di misurazione, attualmente disponibile in Campania.",
          "Avvertenza mostrata nei moduli: non inserire diagnosi, patologie, prescrizioni, referti o altre informazioni relative alla salute. Il modulo è destinato esclusivamente alla richiesta di contatto e alla prenotazione del servizio.",
          "L'utente è responsabile dell'esattezza e dell'aggiornamento dei dati comunicati. Medisistem può non dare seguito a richieste incomplete, illecite, abusive o manifestamente automatizzate.",
        ],
      },
      {
        h: "6. Contenuti, immagini e disponibilità delle informazioni",
        p: [
          "Medisistem cura l'aggiornamento dei contenuti del Sito, ma le informazioni su assortimento, caratteristiche, immagini, disponibilità e servizi possono essere modificate. Le immagini hanno funzione illustrativa e possono presentare differenze non sostanziali rispetto al prodotto, fermo restando il diritto del consumatore a ricevere beni conformi alle informazioni contrattuali applicabili.",
        ],
      },
      {
        h: "7. Proprietà intellettuale",
        p: [
          "Testi, immagini, marchi, loghi, grafica, struttura, banche dati e altri contenuti del Sito sono protetti dalla normativa applicabile e appartengono a Medisistem o ai rispettivi titolari. La consultazione del Sito non trasferisce alcun diritto di proprietà intellettuale all'utente. È consentito salvare o stampare contenuti per uso personale e non commerciale, senza modificarli e mantenendo le indicazioni di titolarità. Ogni altro utilizzo richiede l'autorizzazione del titolare dei diritti.",
        ],
      },
      {
        h: "8. Collegamenti e servizi di terzi",
        p: [
          "Il Sito può contenere collegamenti o componenti forniti da terzi, come Google Maps. Medisistem non controlla i contenuti dei siti esterni e invita l'utente a consultare le relative condizioni e informative. I servizi non necessari che comportano il trattamento di dati o l'uso di strumenti di tracciamento restano bloccati fino alla scelta dell'utente, secondo quanto indicato nella Cookie Policy.",
        ],
      },
      {
        h: "9. Sicurezza, continuità e responsabilità",
        p: [
          "Medisistem adotta misure ragionevoli per proteggere il Sito e mantenerlo disponibile. Possono tuttavia verificarsi sospensioni per manutenzione, aggiornamenti, guasti, eventi di sicurezza o cause non controllabili. Nessuna disposizione delle presenti Condizioni limita o esclude responsabilità o diritti che non possono essere limitati o esclusi per legge, inclusi i diritti inderogabili dei consumatori.",
        ],
      },
      {
        h: "10. Privacy e cookie",
        p: [
          "Il trattamento dei dati personali è descritto nella Privacy Policy. L'utilizzo di cookie e tecnologie analoghe è descritto nella Cookie Policy. Entrambi i documenti sono accessibili dal footer e vicino ai moduli pertinenti.",
        ],
      },
      {
        h: "11. Modifiche alle Condizioni",
        p: [
          "Medisistem può aggiornare le presenti Condizioni per adeguarle a modifiche normative, tecniche o organizzative. La versione aggiornata è pubblicata sul Sito con indicazione della data di aggiornamento e si applica dalla pubblicazione, senza incidere retroattivamente sui rapporti già conclusi.",
        ],
      },
      {
        h: "12. Legge applicabile e tutela dell'utente",
        p: [
          "Le presenti Condizioni sono regolate dalla legge italiana. Restano ferme le norme imperative applicabili e, per il consumatore, le tutele e il foro inderogabile previsti dalla normativa del luogo in cui risiede o è domiciliato.",
        ],
      },
      {
        h: "13. Contatti",
        p: [
          "Per segnalazioni relative al Sito o ai suoi contenuti è possibile scrivere a info@medisistem.it oppure utilizzare i recapiti indicati nella sezione Contatti.",
        ],
      },
    ]}
  />
);

export default TerminiCondizioni;
